import React, { useContext } from 'react';
import { EditCellContext } from 'src/contexts/EditCellContext';

import { GridCellProps } from '@progress/kendo-react-grid';
import { informationIcon } from 'src/utils/icons';

const InfoButton: React.ComponentType<GridCellProps> = (props) => {
  const [cellClick] = useContext(EditCellContext);
  const func = cellClick?.('');
  const handleClick = () => {
    func?.cellClick?.(props.dataItem);
  };
  return (
    <td onClick={handleClick}>
      <div className="flex justify-center items-center hover:cursor-pointer">{informationIcon}</div>
    </td>
  );
};

export default InfoButton;
